<div class="contact-form contact-form-inputs-filled contact-form-inputs-circle contact-form-button-block contact-form-button-circle mb-60 mt-40">
  <form #formElement="ngForm">
    <div class="row">
      <div class="lqd-column col-md-4" *ngFor="let form of forms">
        <div class="col-md-12" *ngFor="let control of form">
          <app-form-control [control]="control" [form]="formElement"></app-form-control>
        </div>
      </div>
    </div>
  </form>
</div>
